import styled, { createGlobalStyle } from 'styled-components'
// themes
import { colors } from 'themes/index'
// views
import {
  Container,
  RisksContainerWrapper
} from 'components/PageComponents/Risks/Register/components/RiskView/components/RisksContainer/views'

export const EmptyPlaceholder = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100% - 40px);
  color: ${colors.purple300};
`

export const GlobalStyles = createGlobalStyle`
    ${RisksContainerWrapper} {
        overflow: unset;
        padding: 0;
    }

    ${Container} {
        height: 100%;
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;

        > div > div:first-child {
            z-index: 99 !important;
        }

        > div > div > div:nth-child(2) {
            padding-left: 20px;
        }
    }
`
